import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../zodios/client";

interface LandingPage {
  productIds?: number[];
  pageType: string;
  url?: string;
}

export function useSBOptimizationRecommendations({
  marketplace,
  landingPages,
  enabled = false,
}: {
  marketplace: string;
  landingPages: LandingPage[];
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: [{ entity: "sbOptimizationRecommendations", marketplace, landingPages }],
    queryFn: async () =>
      await apiClient.getSBOptimizationRecommendations({
        marketplace,
        landing_pages: landingPages,
      }),
    enabled: enabled && landingPages.length > 0,
  });
}
